import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useCompanyFeatures } from 'app/domains/companies';
import { DeleteDocumentDialog, DownloadDocumentDialog, MoveDialog } from 'app/domains/filesystem';
import { ManageProjectsMenu } from 'app/domains/projects';
import { EntryKind } from 'shared/domains/apollo/generated/types';
export function DocumentActionMenu(props) {
    const { cacheId, entityId, parentId, typename } = props;
    const { isFeatureAvailable } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('projects');
    const [open, setOpen] = useState(false);
    const [showProjectsMenu, seShowProjectsMenu] = useState(false);
    const [actionDialog, setActionDialog] = useState();
    const menuItemClickHandler = (dialogType) => () => {
        setActionDialog(dialogType);
        setOpen(false);
    };
    const closeDialog = () => setActionDialog(undefined);
    const openProjectsMenu = () => {
        setOpen(false);
        seShowProjectsMenu(true);
    };
    const closeProjectsMenu = () => seShowProjectsMenu(false);
    const handleUpdate = (cache) => {
        cache.modify({
            id: cache.identify({ id: cacheId, __typename: typename }),
            fields(_, { DELETE }) {
                return DELETE;
            },
        });
    };
    const target = (<IconButton appearance="ghost" size="xs" onClick={() => setOpen(!open)}>
      <Falcon icon="ellipsis-h"/>
    </IconButton>);
    if (showProjectsMenu) {
        return (<ManageProjectsMenu documentId={entityId} initiallyOpen={showProjectsMenu} onClose={closeProjectsMenu} renderTarget={target}/>);
    }
    return (<Fragment>
      <Menu.Root open={open} onClose={() => setOpen(false)} target={target}>
        {isProjectsAvailable && (<Menu.Item onClick={openProjectsMenu}>
            <Falcon icon="rectangle-history"/>
            <Trans comment="Search Table Row Context Menu item - Projects">Edit projects</Trans>
          </Menu.Item>)}
        <Menu.Item onClick={menuItemClickHandler('download')}>
          <Falcon icon="download"/>
          <Trans comment="Search Table Row Context Menu item - Download">Download</Trans>
        </Menu.Item>
        <Menu.Item onClick={menuItemClickHandler('moveToFolder')}>
          <Falcon icon="folder"/>
          <Trans comment="Search Table Row Context Menu item - Move to folder">Move to folder</Trans>
        </Menu.Item>
        <Menu.Item onClick={menuItemClickHandler('delete')}>
          <Falcon icon="trash"/>
          <Trans comment="Search Table Row Context Menu item - Delete">Delete</Trans>
        </Menu.Item>
      </Menu.Root>

      {actionDialog === 'download' && <DownloadDocumentDialog id={entityId} onClose={closeDialog}/>}

      {actionDialog === 'moveToFolder' && (<MoveDialog type={EntryKind.Document} payload={{ id: entityId }} parentId={parentId} onClose={closeDialog}/>)}

      {actionDialog === 'delete' && (<DeleteDocumentDialog id={entityId} onClose={closeDialog} onUpdate={handleUpdate}/>)}
    </Fragment>);
}
